import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SubmitBtn',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<'submit' | 'button'>,
      default: 'submit',
    },
  },
  setup() {
    return {}
  },
})
